import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useFetchActiveMoreOnUsQuery } from '../../../features/API/user-api-slice';
import { CardBody, PageTitle } from '../../text';
import { Button } from '../../UI/button';
import Spinner from '../../UI/spinner';


const Moreonus = () => {
  const { t } = useTranslation();
  const { data = [], isFetching } = useFetchActiveMoreOnUsQuery();
  const history = useHistory();
  const selectedLanguage = useSelector(
    (state) => state.global.selectedLanguage
  );
  const moreonus = data.results;

  // Function to truncate text to a specific word count
  const truncateText = (text, wordLimit) => {
    if (!text) return '';
    const words = text.split(' ');
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(' ') + '...';
  };

  // Get plain text from HTML content
  const getPlainText = (htmlContent) => {
    if (!htmlContent) return '';
    const div = document.createElement('div');
    div.innerHTML = htmlContent;
    return div.textContent || div.innerText || '';
  };

  return isFetching ? (
    <Spinner />
  ) : (
    <div className="bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4">
        <PageTitle
          name={t('About us')}
          color="red"
          alignment="center"
          mobileAlignment="center"
          additional="mb-8"
        />
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="flex md:space-x-6">
            <div className="hidden md:block w-1 bg-red-600 rounded-full"></div>
            <div className="flex-1">
              <CardBody
                name={truncateText(getPlainText(moreonus.description[selectedLanguage]), 50)}
                additional="text-justify text-gray-700 mb-6 leading-relaxed"
              />
              <div className="text-center">
                <Button
                  name={t('Read More')}
                  isSquare
                  outline="false"
                  color="red"
                  additional="px-8 py-3 text-sm font-semibold"
                  clicked={() => {
                    history.push('/aboutus');
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Moreonus;
